export const formatDateString = (someDate) => {
  if (!someDate) return someDate;

  return someDate.toISOString().substring(0, 10);
};
